module.exports = __webpack_public_path__ + "static/media/living_kitchen_brown.4e2c4077.jpg";